import { Checkbox, FormControl, FormErrorMessage, FormHelperText, Textarea } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { BusinessSecretNote } from "../BusinessSecretNote";

export const MAX_SECRET_REASON_LENGTH = 2000;

interface Props {
  label: string;
  readOnlyLabel: string;
  reason: string | null;
  isReadOnly: boolean;
  onChange: (reason: string | null) => void;
}

export const BusinessSecretMark = ({ label, readOnlyLabel, reason, isReadOnly, onChange }: Props) => {
  const { t } = useTranslation();
  const marked = reason !== null;

  if (isReadOnly) {
    return marked ? <BusinessSecretNote label={readOnlyLabel} reason={reason} /> : null;
  }

  const missingReason = marked && reason.trim().length === 0;
  return (
    <FormControl isInvalid={missingReason} mt="2">
      <Checkbox size="sm" isChecked={marked} onChange={(e) => onChange(e.target.checked ? "" : null)}>
        {label}
      </Checkbox>
      {marked && (
        <>
          <Textarea
            mt="2"
            rows={2}
            bg="smBackground"
            maxLength={MAX_SECRET_REASON_LENGTH}
            aria-label={t("Why is this a business secret?") ?? undefined}
            placeholder={t("Why is this a business secret?") ?? undefined}
            value={reason}
            onChange={(e) => onChange(e.target.value)}
          />
          {missingReason ? (
            <FormErrorMessage>{t("Say why, or remove the mark.")}</FormErrorMessage>
          ) : (
            <FormHelperText>
              {t(
                "The buyer has a duty of confidentiality for information that is a business secret (FOA § 7-4 / forsyningsforskriften § 7-3, cf. forvaltningsloven § 13). Your mark and reason help the buyer assess this, but the buyer decides what is confidential.",
              )}
            </FormHelperText>
          )}
        </>
      )}
    </FormControl>
  );
};
